/**
 * Sizes of the app shell that script needs as numbers. The CSS tokens in
 * index.css (`--size-sidebar`, `--size-sidebar-collapsed`) size the sidebar
 * itself; these mirror them (a test keeps the two in step) so the assistant
 * panel can tell how much width the page keeps beside it.
 */
export const SIDEBAR_WIDTH_PX = 232
export const SIDEBAR_COLLAPSED_WIDTH_PX = 68

/**
 * The region a page renders in, as a size container. A page lays out against
 * the width it actually has - narrower whenever the assistant panel docks
 * beside it - with `@<size>/main:` variants, where a viewport breakpoint
 * (`lg:`) would still report the whole window.
 */
export const MAIN_CONTAINER_CLASS = '@container/main'
